import { ListResponse } from "../../../model/common/ListResponse";
import { ListCategory } from "../../../model/ListCategory";
import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";
import { HttpResponse } from "../../../network/types";

import {
  GetFaqCategoryQuery,
  GetFaqListRequest,
  GetFaqListResponse,
} from "./types";

const url = "/repair-shop/faqs";
export const getFAQList = async (queryParams: GetFaqListRequest) => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url,
    queryParams: { ...queryParams, service: "REPAIR_SHOP_WEB" },
  });
  const res: GetFaqListResponse = {
    faqList: response?.data.rows,
    count: response?.data.count,
  };
  return res;
};
export const getFaqCategories = async (
  queryParams: GetFaqCategoryQuery
): Promise<ListResponse<ListCategory>> => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url: "/repair-shop/faq-categories",
    queryParams: { ...queryParams, service: "REPAIR_SHOP_WEB" },
  });

  return {
    rows: response?.data.rows,
    count: response?.data.count,
  };
};
